import React from "react";
import { SectionHeading } from "~/components/DetailsPage/components";
import { Box, Grid } from "@mui/material";
import { TicketProgress } from "~/pages/tickets/ticket/TicketPage/TicketProgress/TicketProgress";

type CaseActivitiesSectionProps = {
  fixedRefs: number;
  totalRefs: number;
};

export const TicketActivitiesSection = ({
  fixedRefs,
  totalRefs,
}: CaseActivitiesSectionProps) => {
  return (
    <Grid size={12}>
      <SectionHeading heading="Ticket Activity" />
      <Box className="section-content">
        <TicketProgress fixedRefs={fixedRefs} totalRefs={totalRefs} />
      </Box>
    </Grid>
  );
};
